<template>
    <div :class="'vue timparty-cluster-widget cluster-widget pt-3'" v-if="user">
         <div class="text-center">
            <img :src="user.cluster_image" class="cluster-image">
          </div>
          <span class="cluster-info">Sei <span class="cluster-name" :style="'color: ' + user.cluster_color + ' !important'">{{ user.cluster_name }}</span></span>
    </div>
</template>

<script>

    /* eslint-disable */ 

    

    import TimPartyMixin from '../mixins/TimPartyMixin';

    

    export default {
      name: 'ClusterWidget',
      mixins: [ TimPartyMixin ],
    


    }
  </script>


